<div class="page-content container">
  <div class="page-header">
    <h1>{{ translationManager.getTranslation('bob_label_63469575d613cb0be0d4f477') }}{{customHeaderText}}</h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span><i class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Страница за приказ комерцијално правних услова') }}</span>
      </div>
    </div>
    <div class="app-table-panel" app-table>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="conditionName">
                  {{translationManager.getTranslation('att_label_63469599d613cb0be0d4f47b')}}
                </a>
              </th>
              <th>
                {{translationManager.getTranslation('Испуњеност услова')}}
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="documentName">
                  {{translationManager.getTranslation('Документ')}}
                </a>
              </th>
              <th style="width: 100px" class="right">{{ translationManager.getTranslation('Акције') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let xxx of items">
              <td>{{xxx.conditionName}}</td>
              <td>
                <input type="checkbox" [ngModel]="xxx['value']" [disabled]="true">
              </td>
              <td>
                <a href="javascript:;"
                  (click)="downloadFile(xxx['supplierOfferLegalTermsDocumentId'], xxx['documentName'])"
                  [title]="translationManager.getTranslation('Преузми документ')">
                  {{xxx['documentName']}}
                </a>
              </td>
              <td class="right">
                <div class="table-actions">
                  <a *ngIf="(state == viewState.Create || state == viewState.Edit)" href="javascript:;"
                    (click)="edit(xxx)" [title]="translationManager.getTranslation('Измена')"><i
                      class="far fa-file-alt"></i></a>
                  <a *ngIf="xxx['documentContent'] && (state == viewState.Create || state == viewState.Edit)"
                    href="javascript:;" (click)="removeDocument(xxx)" class="red"
                    [title]="translationManager.getTranslation('Брисање')">
                    <i class="far fa-trash-alt"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>
      <div class="app-table-pagination">
        <div>
          <div pagination><span>{{ translationManager.getTranslation('Страна') }}</span><select pagination-pages>
              <option>1</option>
            </select><span>{{ translationManager.getTranslation('од') }}</span><span
              pagination-pages-count>-</span><span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на почетак')"
                pagination-first-page><i class="fas fa-angle-double-left"></i></a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Претходна')"
                pagination-previous-page><i class="fas fa-angle-left"></i></a></span><span
              class="app-table-pagination-arrows"><a href="javascript:;"
                [title]="translationManager.getTranslation('Следећа')" pagination-next-page><i
                  class="fas fa-angle-right"></i></a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page><i
                  class="fas fa-angle-double-right"></i></a>
            </span><span>{{ translationManager.getTranslation('Број редова за приказ') }}</span><select
              pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select></div>
        </div>
        <div class="app-table-pagination-sizes">
          <div><span>{{ translationManager.getTranslation('Укупан број слогова') }}</span><span
              pagination-total-count>-</span></div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal [show]="showDeleteModal" (onHide)="showDeleteModal = false" [title]="translationManager.getTranslation('Брисање')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете приложени документ?')
      }}</label>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()"><i class="fa fa-check mr-2"></i>{{
      translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning"><i class="fa fa-times mr-2"></i>{{
      translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<app-modal [show]="displayEditDlg" (onHide)="displayEditDlg = false" [title]="translationManager.getTranslation('Измена')">

  <div class="app-modal-content" *ngIf="form">
    <div class="page-part">
      <div class="form-element"
        [ngClass]="{ 'error': form.elements['value'].error.required || form.elements['value'].error.invalid }">
        <label style="margin-right: 10px;">{{translationManager.getTranslation('Испуњеност услова')}}</label>
        <input type="checkbox" [(ngModel)]="form.elements['value'].value">
      </div>
    </div>

    <div class="page-part">
      <div class="form-element"
        [ngClass]="{ 'error': form.elements['value'].error.required || form.elements['value'].error.invalid }">

        <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
          <div style="margin-top:  5px; margin-bottom:  5px;">
            <button (click)="file.click()"><i class="fa fa-file-alt mr-1"></i> {{
              translationManager.getTranslation('Додаj нови документ') }}</button>
            <input type="file" id="file" accept="application/pdf,application/vnd.ms-excel, application/msword,
              application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg"
              (change)="handleFileInput($event.target.files)" #file style="display :none;">
          </div>
          <div style="margin-top:  5px; margin-bottom:  5px;">
            <a *ngIf="form.elements['documentContent']?.value" href="javascript:;" (click)="downloadFile1(selectedItem)"
              [title]="translationManager.getTranslation('Преузми документ')" style="margin-right: 10px;">
              {{this.form.elements['documentName'].value}}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="page-part" *ngIf="deleteDocumentShow">
      <div class="form-element">
        <label style="margin-right: 10px;color:red">{{translationManager.getTranslation('Брисање')}}</label>
        <input type="checkbox" [(ngModel)]="deleteDocument">
      </div>
    </div>
  </div>

  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="save()"><i class="fa fa-check mr-2"></i>{{
      translationManager.getTranslation('Сачувај') }}</button>
    <button (click)="displayEditDlg = false" class="btn btn-warning"><i class="fa fa-times mr-2"></i>{{
      translationManager.getTranslation('Одустани') }}</button>
  </div>

</app-modal>
